/**
 * @Description 小天才-pc企微环境下免登页
 */

import { FC, useEffect } from 'react';
import { Spin } from 'antd';
import { isMobile, urlParams } from '@lhb/func';
import { getStorage, removeStorage, setCookie, setStorage } from '@lhb/cache';
import { useMethods } from '@lhb/hook';
import { isWeComEnv } from '@/common/utils/ways';
import { getWeComAuthorizeLink, loginQW } from '@/common/api/wecom';
// import cs from 'classnames';
import styles from './entry.module.less';
import V2Message from '@/common/components/Others/V2Hint/V2Message';

interface XTCWeComExemptionProps {

};
const XTCWeComExemption: FC<XTCWeComExemptionProps> = () => {
  useEffect(() => {
    if (!isWeComEnv()) {
      V2Message.warning('非企微环境内');
      return;
    };
    // code 是获取完重定向地址之后，跳转到重定向地址的链接中携带的参数
    const code = urlParams(location.search)?.code;
    // 应用后台配置的应用地址跳转过来时携带的参数
    const urlCorpId = urlParams(location.search)?.corpId;
    // 从工作台的应用入口进入时
    if (!code && urlCorpId) {
      methods.getAuthorizeLink(urlCorpId);
      return;
    }
    // 跳转到授权地址后才会执行到此逻辑，此时url中包含了code
    const corpId = getStorage('flowCorpId');
    // 包含code的时候进行登录操作
    if (code && corpId) {
      methods.handleLogin(code, corpId);
    }
  }, []);


  const methods = useMethods({
    // 获取网页的授权链接
    async getAuthorizeLink(corpId) {
      const originStr = encodeURIComponent(window.location.href); // 当前地址
      try {
        const res = await getWeComAuthorizeLink({
          redirectUri: originStr,
          corpId,
          scope: 'snsapi_base'
        });
        const { url } = res || {};
        if (url) {
          setStorage('flowCorpId', corpId); // 存储corpId
          window.location.href = url;
        }
      } catch (error) {
        // Toast.show('获取获取网页授权地址失败：/tp/wx/oauth2/authorize');
        V2Message.error('获取获取网页授权地址失败：/tp/wx/oauth2/authorize');
      }
    },
    async handleLogin(code, corpId) {
      loginQW({
        code,
        corpId,
      }).then((res) => {
        const {
          employeeId, // 对应租户下的员工id
          token,
          tenantId,
        } = res;

        // 存储相关状态，访问应用

        tenantId && setCookie('tenantId', tenantId);
        employeeId && setCookie('employeeId', employeeId);
        token && setCookie('flow_token', token);
        removeStorage('flowCorpId'); // 存储corpId

        setTimeout(() => {
          if (isMobile()) {
            // 移动端用的是大写，
            tenantId && setCookie('TENANT_ID', tenantId);
            employeeId && setCookie('EMPLOYEE_ID', employeeId);
            // 直接写死
            window.location.href = 'https://mallmap-h5.okii.com/home';
          } else {
            window.location.href = '/';
          }
        }, 100);
      }).catch(() => {
        V2Message.error('登录失败-接口调用出错');
      });
    },
  });

  return (
    <div className={styles.container}>
      <Spin size='large' tip='登录中...'/>
    </div>
  );
};

export default XTCWeComExemption;
